import {useCallback, useEffect, useRef} from 'react'

type Trigger = () => void
type Callback = () => void

const RELOAD_MESSAGE = 'reload'

/**
 * タブを越えて健康管理の利用状況チェックをトリガーするためのフック
 * @param callback 他のタブから利用状況チェックがトリガーされた時のコールバック
 */
export const useBroadcastReloadHealthcareStatus = (callback?: Callback): Trigger => {
  const channelRef = useRef<BroadcastChannel>()
  const callbackRef = useRef<Callback>()
  callbackRef.current = callback

  useEffect(() => {
    if (!window.BroadcastChannel) {
      return
    }

    const ch = new BroadcastChannel('features/healthcare/useBroadcastReloadHealthcareStatus')
    channelRef.current = ch

    ch.addEventListener('message', (event) => {
      if (event.data === RELOAD_MESSAGE) {
        callbackRef.current?.()
      }
    })

    return () => ch.close()
  }, [])

  return useCallback(() => {
    channelRef.current?.postMessage(RELOAD_MESSAGE)
  }, [])
}
